import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { ceilNumber } from "@/utils/number";
import { FrameName } from "../config";
import type { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class OutpostBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.OUTPOST;

	public get storage(): Map<ResourceType, number> {
		const storage = new Map<ResourceType, number>(super.storage);

		// Apply upgrades for each resource in the storage map.
		for (const resource of storage.keys()) {
			let resourceStorage = (storage.get(resource) as number) || 0;
			resourceStorage *=
				1 + getUpgradeCurrentReplaceValueById(UpgradeIds.tents);
			resourceStorage = ceilNumber(resourceStorage);
			storage.set(resource, resourceStorage);
		}

		return storage;
	}
}

export default OutpostBuildingTileEntity;
